<template>
  <!-- 底部的下载按钮 -->
  <div class="download-btn show-flex-box-r">
    <div class="download-click-button-box" >
      <div>
        <open-app-button :appParams='appParams' :buttonText="buttonText" />
      </div>
    </div>
  </div>
</template>

<script>
import openAppButton from '@/components/common/open_app_button_comp';

export default {
  props: {
    appParams: [String],
    buttonText: {
      type: [String],
      default: '打开 APP 查看更多信息'
    }
  },
  components: {
    openAppButton
  },
  data() {
    return {

    };
  },
  methods: {
    
  },
  watch: {}
};
</script>

<style lang="less">
  .download-btn {
    width: 100%;
    &>.download-click-button-box {
      width: 100%;
      padding: 0.07rem 0.15rem;
      box-sizing: border-box;
      box-shadow: 0 -0.04rem 0.13rem 0 rgba(196, 200, 206, 0.31);
      background: #ffffff;
      &>div {
        flex-grow: 1;
        height: 0.4rem;
        background: #9ad64c;
        border-radius: 0.4rem;
        opacity: 0.84;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/basic/footer_download_button.vue